import { ADD_NOTICE } from './constants';

export const addNotice = data => dispatch => {
    dispatch({
        type: ADD_NOTICE,
        data,
    });
};
